/*! zk-footer-trust-fb — trust strip + feedback modal at top of footer */
(function () {
  'use strict';
  if (window.__zkFooterTrustFb) return;
  window.__zkFooterTrustFb = true;

  var LOGO =
    (window.__zkFt && (window.__zkFt.logoDark || window.__zkFt.logo)) ||
    'https://zariknyaa.com/cdn/shop/files/zariknyaa_logo_7_e24b3c3c-e220-4e0b-8368-a46bc49e5b9d.png?v=1719289612&width=160';

  function ensureFonts() {
    if (document.getElementById('zk-ft-fonts')) return;
    var link = document.createElement('link');
    link.id = 'zk-ft-fonts';
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Jost:wght@400;500;600;700&display=swap';
    document.head.appendChild(link);
  }

  function stripHtml() {
    return (
      '<div class="zk-ft-wrap" data-zk-ft>' +
      '<div class="zk-ft">' +
      '<section class="zk-ft__card zk-ft__trust" aria-label="Trust">' +
      '<span class="zk-ft__badge" aria-label="Zariknyaa Trust">' +
      '<img class="zk-ft__badge-logo" src="' +
      LOGO +
      '" alt="Zariknyaa" width="90" height="28" loading="lazy" />' +
      '<svg class="zk-ft__badge-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">' +
      '<path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/>' +
      '<path d="M12 5 9.04 7.96a2.17 2.17 0 0 0 0 3.08c.82.82 2.13.85 3 .07l2.07-1.9a2.82 2.82 0 0 1 3.79 0l2.96 2.66"/>' +
      '<path d="m18 15-2-2"/><path d="m15 18-2-2"/>' +
      '</svg>' +
      '<span class="zk-ft__badge-trust">Trust</span>' +
      '</span>' +
      '<div class="zk-ft__icons">' +
      '<div class="zk-ft__icon">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"/><path d="m9 12 2 2 4-4"/></svg>' +
      '<span>Authentic weaves</span></div>' +
      '<div class="zk-ft__icon">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 22v-9"/><path d="M15.17 2.52a2 2 0 0 0-2.34 0L3.7 8.1a1 1 0 0 0 0 1.7l9.13 5.58a2 2 0 0 0 2.34 0l9.13-5.58a1 1 0 0 0 0-1.7z"/><path d="M20 13.5V18a2 2 0 0 1-1.1 1.8l-6 3a2 2 0 0 1-1.8 0l-6-3A2 2 0 0 1 4 18v-4.5"/><path d="m7 10.5 5 3 5-3"/></svg>' +
      '<span>Easy returns</span></div>' +
      '<div class="zk-ft__icon">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><rect width="20" height="14" x="2" y="5" rx="2"/><path d="M2 10h20"/></svg>' +
      '<span>Easy payments</span></div>' +
      '</div></section>' +
      '<aside class="zk-ft__card zk-ft__fb" aria-label="Feedback">' +
      '<span class="zk-ft__illu" aria-hidden="true">' +
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"/><path d="M15.8 9.2a2.5 2.5 0 0 0-3.5 0l-.3.4-.35-.3a2.42 2.42 0 1 0-3.2 3.6l3.6 3.5 3.6-3.5c1.2-1.2 1.1-2.7.2-3.7"/></svg>' +
      '</span>' +
      '<div class="zk-ft__copy">' +
      '<h3>Let us know how you feel</h3>' +
      '<p>It’ll only take <b>2 minutes</b>.</p>' +
      '</div>' +
      '<button type="button" class="zk-ft__btn" data-zk-fb-open>Give Feedback</button>' +
      '</aside></div></div>'
    );
  }

  function modalHtml() {
    return (
      '<div class="zk-fb-modal" id="zk-fb-modal" aria-hidden="true" role="dialog" aria-modal="true" aria-labelledby="zk-fb-title">' +
      '<div class="zk-fb-modal__backdrop" data-zk-fb-close></div>' +
      '<div class="zk-fb-modal__panel">' +
      '<button type="button" class="zk-fb-modal__close" data-zk-fb-close aria-label="Close">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg></button>' +
      '<div class="zk-fb-step is-active" data-step="1">' +
      '<h2 class="zk-fb-modal__title" id="zk-fb-title">Tell us how we can improve</h2>' +
      q('browse', 'Are you happy with your browsing experience?', 'Browsing experience') +
      q('layout', 'Do you like the page layout &amp; design?', 'Layout and design') +
      q('info', 'Did you get all necessary product information?', 'Product information') +
      q('offers', 'Are the product offers clear?', 'Product offers') +
      '<div class="zk-fb-actions"><button type="button" class="zk-fb-btn zk-fb-btn--outline-sage" data-zk-fb-next>Next</button></div>' +
      '</div>' +
      '<div class="zk-fb-step" data-step="2">' +
      '<h2 class="zk-fb-modal__title">Tell us how we can improve</h2>' +
      q('recs', 'Are the product recommendations relevant?', 'Recommendations') +
      '<div class="zk-fb-note"><p class="zk-fb-note__label">Is there any other feedback you’d like to share?</p>' +
      '<div class="zk-fb-note__box"><textarea id="zk-fb-text" maxlength="350" placeholder="Tell us how we can improve!"></textarea>' +
      '<span class="zk-fb-note__count"><span data-zk-fb-count>0</span>/350</span></div></div>' +
      '<div class="zk-fb-actions zk-fb-actions--split">' +
      '<button type="button" class="zk-fb-btn zk-fb-btn--ghost" data-zk-fb-back>Back</button>' +
      '<button type="button" class="zk-fb-btn zk-fb-btn--sage" data-zk-fb-to-confirm>Submit</button></div></div>' +
      '<div class="zk-fb-step" data-step="3"><div class="zk-fb-confirm">' +
      '<img class="zk-fb-confirm__art" src="https://cdn.jsdelivr.net/npm/undraw-svg@2.0.0/svgs/feeling-happy.svg" alt="" width="220" height="160"/>' +
      '<h3>Are you sure you want to submit?</h3>' +
      '<div class="zk-fb-actions zk-fb-actions--stack" style="margin-top:20px">' +
      '<button type="button" class="zk-fb-btn zk-fb-btn--ghost" data-zk-fb-submit>Exit and Submit</button>' +
      '<button type="button" class="zk-fb-btn zk-fb-btn--sage" data-zk-fb-back>Complete Feedback</button></div></div></div>' +
      '<div class="zk-fb-step" data-step="4"><div class="zk-fb-thanks">' +
      '<p class="zk-fb-thanks__eyebrow">Thank you</p>' +
      '<img class="zk-fb-thanks__art" src="https://cdn.jsdelivr.net/npm/undraw-svg@2.0.0/svgs/appreciate-it.svg" alt="" width="220" height="160"/>' +
      '<h3>Thank you for sharing your feedback!</h3>' +
      '<p>Your words help us weave a better experience.</p>' +
      '<div class="zk-fb-actions" style="justify-content:center">' +
      '<button type="button" class="zk-fb-btn zk-fb-btn--sage" data-zk-fb-done>Continue Shopping</button></div></div></div>' +
      '</div></div>'
    );
  }

  function q(key, label, aria) {
    return (
      '<div class="zk-fb-q" data-q="' +
      key +
      '"><p class="zk-fb-q__label">' +
      label +
      '</p><div class="zk-fb-scale" role="radiogroup" aria-label="' +
      aria +
      '"></div></div>'
    );
  }

  function findDarkFooter() {
    // Dark newsletter block inside Zariknyaa footer (below Free shipping chips)
    return (
      document.querySelector('.zkf-section .zkf-main') ||
      document.querySelector('.zkf-main') ||
      document.querySelector('.shopify-section-footer .zkf-main')
    );
  }

  function findFooterFallback() {
    return (
      document.querySelector('.zkf-section') ||
      document.querySelector('.shopify-section-group-footer-group') ||
      document.querySelector('footer.footer') ||
      document.querySelector('footer')
    );
  }

  function placeStrip(node) {
    var dark = findDarkFooter();
    if (dark && dark.parentNode) {
      // Sit just above the dark footer, after Free shipping / COD / etc.
      dark.parentNode.insertBefore(node, dark);
      return true;
    }
    var footer = findFooterFallback();
    if (!footer) return false;
    // Prefer append inside footer section (bottom), not before whole group
    footer.appendChild(node);
    return true;
  }

  function injectStrip() {
    var existing = document.querySelector('[data-zk-ft]');
    var dark = findDarkFooter();
    if (existing) {
      // Relocate if it was injected above Free shipping (wrong spot)
      if (dark && existing.nextElementSibling !== dark) {
        dark.parentNode.insertBefore(existing, dark);
      }
      return true;
    }
    var wrap = document.createElement('div');
    wrap.innerHTML = stripHtml();
    var node = wrap.firstChild;
    if (!placeStrip(node)) return false;
    var img = node.querySelector('.zk-ft__badge-logo');
    if (img && window.__zkFt && window.__zkFt.logoDark) {
      img.src = window.__zkFt.logoDark;
    }
    return true;
  }

  function injectModal() {
    if (document.getElementById('zk-fb-modal')) return true;
    var wrap = document.createElement('div');
    wrap.innerHTML = modalHtml();
    document.body.appendChild(wrap.firstChild);
    return true;
  }

  /* Lucide faces (ISC) */
  var faces = [
    { name: 'angry', svg: '<circle cx="12" cy="12" r="10"/><path d="M16 16s-1.5-2-4-2-4 2-4 2"/><path d="M7.5 8 10 9"/><path d="m14 9 2.5-1"/><path d="M9 10h.01"/><path d="M15 10h.01"/>' },
    { name: 'frown', svg: '<circle cx="12" cy="12" r="10"/><path d="M16 16s-1.5-2-4-2-4 2-4 2"/><line x1="9" x2="9.01" y1="9" y2="9"/><line x1="15" x2="15.01" y1="9" y2="9"/>' },
    { name: 'meh', svg: '<circle cx="12" cy="12" r="10"/><line x1="8" x2="16" y1="15" y2="15"/><line x1="9" x2="9.01" y1="9" y2="9"/><line x1="15" x2="15.01" y1="9" y2="9"/>' },
    { name: 'smile', svg: '<circle cx="12" cy="12" r="10"/><path d="M8 14s1.5 2 4 2 4-2 4-2"/><line x1="9" x2="9.01" y1="9" y2="9"/><line x1="15" x2="15.01" y1="9" y2="9"/>' },
    { name: 'laugh', svg: '<circle cx="12" cy="12" r="10"/><path d="M18 13a6 6 0 0 1-6 5 6 6 0 0 1-6-5h12Z"/><line x1="9" x2="9.01" y1="9" y2="9"/><line x1="15" x2="15.01" y1="9" y2="9"/>' }
  ];

  function buildScale(scaleEl) {
    scaleEl.innerHTML = '';
    faces.forEach(function (f, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'zk-fb-emo';
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', 'false');
      btn.setAttribute('aria-label', f.name);
      btn.dataset.val = String(i + 1);
      var cap = i === 0 ? 'Not at all' : i === 4 ? 'Yes, a lot' : '';
      btn.innerHTML =
        '<span class="zk-fb-emo__face" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">' +
        f.svg +
        '</svg></span><span class="zk-fb-emo__cap">' +
        cap +
        '</span>';
      btn.addEventListener('click', function () {
        scaleEl.querySelectorAll('.zk-fb-emo').forEach(function (b) {
          b.classList.remove('is-on');
          b.setAttribute('aria-checked', 'false');
        });
        btn.classList.add('is-on');
        btn.setAttribute('aria-checked', 'true');
        scaleEl.dataset.value = btn.dataset.val;
      });
      scaleEl.appendChild(btn);
    });
  }

  function bindModal() {
    var modal = document.getElementById('zk-fb-modal');
    if (!modal || modal.dataset.bound) return;
    modal.dataset.bound = '1';

    modal.querySelectorAll('.zk-fb-scale').forEach(buildScale);

    var answers = {};
    var step = 1;

    function showStep(n) {
      step = n;
      modal.querySelectorAll('.zk-fb-step').forEach(function (s) {
        s.classList.toggle('is-active', s.getAttribute('data-step') === String(n));
      });
    }

    function openModal() {
      answers = {};
      modal.querySelectorAll('.zk-fb-emo').forEach(function (b) {
        b.classList.remove('is-on');
        b.setAttribute('aria-checked', 'false');
      });
      modal.querySelectorAll('.zk-fb-scale').forEach(function (s) {
        delete s.dataset.value;
      });
      var ta = document.getElementById('zk-fb-text');
      if (ta) ta.value = '';
      var c = modal.querySelector('[data-zk-fb-count]');
      if (c) c.textContent = '0';
      showStep(1);
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('zk-fb-open');
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('zk-fb-open');
    }

    function collectStepRatings() {
      modal.querySelectorAll('.zk-fb-step.is-active .zk-fb-q').forEach(function (qEl) {
        var key = qEl.getAttribute('data-q');
        var scale = qEl.querySelector('.zk-fb-scale');
        if (key && scale && scale.dataset.value) answers[key] = scale.dataset.value;
      });
    }

    document.addEventListener(
      'click',
      function (e) {
        var openBtn = e.target.closest && e.target.closest('[data-zk-fb-open]');
        if (openBtn) {
          e.preventDefault();
          openModal();
        }
      },
      true
    );

    modal.querySelectorAll('[data-zk-fb-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });
    modal.querySelector('[data-zk-fb-next]').addEventListener('click', function () {
      collectStepRatings();
      showStep(2);
    });
    modal.querySelectorAll('[data-zk-fb-back]').forEach(function (el) {
      el.addEventListener('click', function () {
        if (step === 2) showStep(1);
        else if (step === 3) showStep(2);
      });
    });
    modal.querySelector('[data-zk-fb-to-confirm]').addEventListener('click', function () {
      collectStepRatings();
      var ta = document.getElementById('zk-fb-text');
      answers.note = ta ? ta.value.trim() : '';
      showStep(3);
    });
    modal.querySelector('[data-zk-fb-submit]').addEventListener('click', function () {
      try {
        window.dispatchEvent(new CustomEvent('zk:feedback', { detail: answers }));
      } catch (err) {}
      showStep(4);
    });
    modal.querySelector('[data-zk-fb-done]').addEventListener('click', closeModal);

    var ta = document.getElementById('zk-fb-text');
    if (ta) {
      ta.addEventListener('input', function () {
        var c = modal.querySelector('[data-zk-fb-count]');
        if (c) c.textContent = String(ta.value.length);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
  }

  function boot() {
    ensureFonts();
    injectStrip();
    injectModal();
    bindModal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  var tries = 0;
  var timer = setInterval(function () {
    tries += 1;
    injectStrip();
    injectModal();
    bindModal();
    if ((document.querySelector('[data-zk-ft]') && document.getElementById('zk-fb-modal')) || tries > 40) {
      clearInterval(timer);
    }
  }, 500);
})();
